<template>
  <ac-circular-progress
    :loading="loading"
    message="Loading..."
    size="64"
    :width="3"
    color="grey"
    indeterminate
  >
    <v-layout column>
      <pin-form
        :pin="pinClone"
        :companies="companies"
        :validate="validate"
        :disable="!permission"
      />
      <v-fab-transition v-if="showSave">
        <v-btn color="accent" dark fab fixed right bottom @click="save">
          <v-icon>save</v-icon>
        </v-btn>
      </v-fab-transition>
    </v-layout>
  </ac-circular-progress>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import PinForm from './pin-form';

export default {
  name: 'pin',
  components: {
    PinForm,
  },
  props: {
    pinRef: String,
  },
  data: () => ({
    loading: false,
    pinClone: {},
    disableSave: false,
    validate: { pin: false },
    acl: ['admin', 'developer'],
  }),
  computed: {
    ...mapGetters({
      inRoles: 'Acacia/Profile/inRoles',
      companies: 'companies',
      pin: 'pin',
    }),
    showSave() {
      return this.validate.pin && this.permission && !this.disableSave;
    },
    permission() {
      return this.inRoles(this.acl);
    },
    saveMethod() {
      return this.pinRef === 'new' ? this.create() : this.update();
    },
  },
  created() {
    this.loadPin();
    this.getCompanies();
  },
  methods: {
    ...mapActions([
      'addSnackbarErrorHandler',
      'addSnackbar',
      'setAcaciaToolbar',
      'getPin',
      'getCompanies',
      'createPin',
      'updatePin',
    ]),
    loadPin() {
      if (this.pinRef === 'new') {
        this.afterLoad({ active: true });
      } else {
        this.loading = true;
        this.getPin(this.pinRef)
          .then(() => {
            this.afterLoad(this.pin);
          }, this.addSnackbarErrorHandler);
      }
    },
    save() {
      this.disableSave = true;
      this.saveMethod
        .then(() => {
          this.addSnackbar({ message: 'Saved Successful' });
          this.$router.replace({ name: 'Pins' });
        })
        .catch(this.addSnackbarErrorHandler);
    },
    create() { return this.createPin(this.pinClone); },
    update() { return this.updatePin(this.pinClone); },
    afterLoad(pin) {
      this.pinClone = Object.assign({}, pin);
      this.setAcaciaToolbar({
        title: this.pinRef === 'new' ? 'New PIN' : `PIN: ${this.pinClone.pin}`,
        back: this.back,
      });
      this.loading = false;
    },
    back() {
      this.$router.replace({ name: 'Pins' });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pin/pin.vue